export default "__VITE_ASSET__YCsWQ8gi__"